<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import FallbackAvatar from '@/components/ui/FallbackAvatar'

  export default {
    name: 'GroupMembers',
    components: {
      FallbackAvatar,
    },
    props: {
      members: Object,
    },
    computed: {
      showMore() {
        return this.members.pagination.self < this.members.pagination.last
      },
    },
    methods: {
      viewMore() {
        this.$emit('onShowMore')
      },
    },
  }
</script>

